import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'

export default function Item() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    // const [name, setName] = useState('')
    const [searchParams, setSearchParams] = useSearchParams()
    let name = searchParams.get('name') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || '1'
    // const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`dbms/items?limit=0&name=${name}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [name])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายละเอียดเมล็ดพันธุ์ข้าว
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">
                        <Link to='/setting/item/add'>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>

                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={name} onChange={e => setSearchParams({ name: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา รหัส / ชื่อ"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="listData row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>

                                    <th class="text-center">ประเภทข้าว</th>
                                    <th class="text-center">ชนิดข้าว</th>
                                    <th class="text-center">พันธุ์</th>
                                    <th class="text-center">ชั้นพันธุ์</th>
                                    <th class="text-center">สารเคมี</th>
                                    <th class="text-center">ฤดู</th>
                                    <th class="text-center">ราคา</th>
                                    <th class="text-center">หน่วย</th>
                                    <th class="text-center">สถานะ</th>

                                </tr>
                            </thead>
                            <tbody class="cp">
                                {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                    <tr style={{cursor:"pointer"}}  className={id === x?.ItemNo ? 'active' : ''} onClick={() => {
                                        setSearchParams({ id: x?.ItemNo, page: page, name: name, })
                                        navigate(`/setting/item/${x.ItemNo}`)}}>

                                        <td class="text-center">{x?.GroupNo?.GroupName}</td>
                                        <td class="text-center">{x?.Option1}</td>
                                        <td class="text-center">{x?.CatalogNo?.CatalogName}</td>
                                        <td class="text-center">{x?.Option2}</td>

                                        <td class="text-center">{x?.Chemical}</td>
                                        <td class="text-center">{x?.Season}</td>
                                        <td class="text-center">{x?.SalePrice}</td>
                                        <td class="text-center">{x?.UnitNo?.UnitName}</td>
                                        <td class="text-center">
                                            {x?.Status === 'Y' ?
                                                <span class="status-active">
                                                    ใช้งาน
                                                </span> :
                                                <span class="status-inactive">
                                                    ไม่ใช้งาน
                                                </span>}
                                        </td>

                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, name: name, id: id })} shape="rounded" />

                    </div >
                </div >
            </div >
        </Page >
    )
}
